(() => {
  const carouselSelector = '.jdgm-cards-carousel';

  const formatDate = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    const parts = new Intl.DateTimeFormat('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(date);
    const part = (type) => parts.find((item) => item.type === type)?.value || '';
    return `${part('year')}/${part('month')}/${part('day')}`;
  };

  const addReviewDates = (carousel) => {
    const blockId = carousel.dataset.jdgmBlockId;
    const reviews = window.jdgmCarouselMode?.[blockId]?.reviews;
    if (!Array.isArray(reviews) || reviews.length === 0) return false;

    const reviewsById = new Map(
      reviews.map((review) => [String(review.uuid || review.id || ''), review]),
    );
    let datedCards = 0;

    carousel.querySelectorAll('.jdgm-card[data-review-id]').forEach((card) => {
      const cardIndex = Number.parseInt(card.dataset.cardIndex || '', 10);
      const review = reviewsById.get(card.dataset.reviewId)
        || (Number.isNaN(cardIndex) ? undefined : reviews[cardIndex]);
      const rawDate = review?.created_at || review?.published_at || review?.updated_at;
      const displayDate = formatDate(rawDate);
      if (!displayDate) return;

      let dateElement = card.querySelector('.jdgm-review-date');
      if (!dateElement) {
        dateElement = document.createElement('time');
        dateElement.className = 'jdgm-review-date';
        const reviewer = card.querySelector('.jdgm-reviewer-info');
        const ratingSection = card.querySelector('.jdgm-rating-section');
        if (reviewer) reviewer.after(dateElement);
        else ratingSection?.appendChild(dateElement);
      }

      const dateTime = String(rawDate).slice(0, 10);
      if (dateElement.dateTime !== dateTime) dateElement.dateTime = dateTime;
      if (dateElement.textContent !== displayDate) dateElement.textContent = displayDate;
      datedCards += 1;
    });

    if (datedCards > 0) carousel.dataset.reviewDatesReady = 'true';
    return datedCards > 0;
  };

  const scan = () => {
    document.querySelectorAll(carouselSelector).forEach(addReviewDates);
  };

  const start = () => {
    scan();
    const observer = new MutationObserver(scan);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    [300, 800, 1800, 4000, 8000].forEach((delay) => {
      window.setTimeout(scan, delay);
    });
    window.setTimeout(() => observer.disconnect(), 12000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
